/**
 * React hook exposing the open/closed state of the user-initiated report modal.
 */

import { useCallback, useEffect, useState } from 'react'
import {
  closeReportModal,
  getReportModalState,
  openReportModal,
  subscribeToReportModal,
} from '../util/ReportModalStore'

/**
 * Subscribes to the shared report modal state.
 * Note: React 17 compatible (uses useState instead of useSyncExternalStore)
 *
 * @returns {Object} - { isOpen, triggerMessage, openModal, closeModal }
 */
export default function useReportModal() {
  const [modalState, setModalState] = useState(getReportModalState)

  useEffect(() => {
    const unsubscribe = subscribeToReportModal(() => {
      setModalState(getReportModalState())
    })

    // Sync with current state in case it changed before subscription
    setModalState(getReportModalState())

    return unsubscribe
  }, [])

  const openModal = useCallback((triggerMessage) => {
    openReportModal(triggerMessage)
  }, [])

  const closeModal = useCallback(() => {
    closeReportModal()
  }, [])

  return { isOpen: modalState.isOpen, triggerMessage: modalState.triggerMessage, openModal, closeModal }
}
